import { FormControl } from '@angular/forms';

export const addressFormGroup = {
  streetName: new FormControl<string | null>(null),
  streetCode: new FormControl<string | null>(null),
  buildingNumber: new FormControl<string | null>(null),
  floorIdentification: new FormControl<string | null>(null),
  roomIdentification: new FormControl<string | null>(null),
  subDivisionName: new FormControl<string | null>(null),
  postalCode: new FormControl<string | null>(null),
  cityName: new FormControl<string | null>(null),
  municipalityCode: new FormControl<string | null>(null),
  country: new FormControl<string | null>(null),
  washInstructions: new FormControl<string | null>(null),
  darReference: new FormControl<string | null>(null),
}
